import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { appConfigs } from "../../../martin/_helpers";
import "./Error.scss"

export default function ErrorsPage() {
  let { type } = useParams();
  document.title = type + " Error — " + appConfigs.app_name;
  const [error, setError] = useState({ message: "500 Error: Internal server error", description: "An internal server error occured." })

  useEffect(() => {
    if (type === '400') setError({ message: `${type} Error: Bad request`, description: "Bad page request." });
    else if (type === '401') setError({ message: `${type} Error: Authorization required`, description: "Authorization is required to view the resource." });
    else if (type === '403') setError({ message: `${type} Error: Forbidden file`, description: "The resource you are trying to access is forbidden." });
    else if (type === '404') setError({ message: `${type} Error: File not found`, description: "The requested resource was not found on this server." });
    else if (type === '500') setError({ message: `${type} Error: Internal server error`, description: "An internal server error occured." });
  }, [type]);

  return (
    <div id="main">
      <div className="fof">
        <h1>{error.message}</h1>
        <p>{error.description}</p>
        <Link to="/"><small><span className="opacity-40">&lt;</span> Go back home <span className="opacity-40">/&gt;</span></small></Link>
      </div>
    </div>
  );
}
